import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
// const baseURL = "http://192.168.1.240:10005";
const baseURL = "";

export default class CreateAccountService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public getRolesSearch(queryForm: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/roles-search`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // get DataByIds
  public getUpdateRoles(id: any, query): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(baseURL + `/api/auth/users/${id}/update`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // get DataByIds
  public getDetailByIds(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseURL + `/api/auth/users/${id}/detail`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // get Create UserAccounts
  public getCreateAccounts(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseURL + `/api/auth/users/create`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // Delete User
  public deleteUsers(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(baseURL + `/api/auth/users/${id}/delete`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
